import { render, staticRenderFns } from "./base.vue?vue&type=template&id=3178986d&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"
import style0 from "./base.vue?vue&type=style&index=0&id=3178986d&prod&scoped=true&lang=css"
import style1 from "./base.vue?vue&type=style&index=1&id=3178986d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178986d",
  null
  
)

export default component.exports